// import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { HttpModule, Http, Headers, RequestOptions,Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';

@Injectable()
export class HotelService {

  private username;

server = '';
  headers: Headers = new Headers;
  options : any;

  constructor(private http:Http) { 
    this.headers.append('enctype','multipart/form-data');
    this.headers.append('Content-Type','application/json');
    this.headers.append('X-Requested-With','XMLHttpRequest');
    this.options = new RequestOptions({headers:this.headers});

    if (location.hostname != "localhost") {
      this.server = "http://" + location.hostname + "/tejashreecode/index.php/hotel/";
    }
    else {
      this.server = "http://" + location.hostname + "/tejashree/tejashreecode/index.php/hotel/";
    }

  }
  logout() {
      // remove user from local storage to log user out
      localStorage.removeItem('currentUser');
  }

  addHotel(info)
  {
    
    var data = JSON.stringify(info);
    //console.log(data);

    return this.http.post(this.server+"addhotel",data,this.options).map(res=>res.json());
  }

  addHotelMaterial(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"addhotelmaterial",data,this.options).map(res=>res.json());
  }

  getAllHotel()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"gethotels", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )

    //return this.http.get(this.server+"gethotels");
  }

  getHotelRates(id)
  {
    var data = JSON.stringify(id);
    
    return this.http.post(this.server+"gethotelsrates",data,this.options).map(res=>res.json());
    
  }

  getHotelList()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"gethotellist", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )
  }

  getOrderList()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"getorderlist", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )
  }

  getHotelOrderById(datas)
  {
    var data = JSON.stringify(datas);
   // console.log(data);
    
    return this.http.post(this.server+"getorderlistbyid",data,this.options).map(res=>res.json());
  }

  getAllHotelinmaterial()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"gethotelsinmaterial", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )
  }

  addHotelBill(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"addhotelbill",data,this.options).map(res=>res.json());
  }

  getViewBill(bill_no)
  {
    var data = JSON.stringify(bill_no);
   // console.log(data);
    
    return this.http.post(this.server+"getviewbill",data,this.options).map(res=>res.json());
  }

  getpayBill(bill_no)
  {
    var data = JSON.stringify(bill_no);
   // console.log(data);
    
    return this.http.post(this.server+"getpayBill",data,this.options).map(res=>res.json());
  }

  addpayBill(info)
  {
    var data = JSON.stringify(info);
    //console.log(data);

    return this.http.post(this.server+"payBill",data).map(res=>res.json());
  }

  addpayBillDirect(info)
  {
    var data = JSON.stringify(info);
    return this.http.post(this.server+"payBillDirect",data).map(res=>res.json())
  }

  getSearchHotelList(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"gethotellist",data,this.options).map(res=>res.json());
  }
  getSearchOrderList(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"getorderlist",data,this.options).map(res=>res.json());
  }

  getBillNos()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"getbillno", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )
  }

  getEditHotel()
  {
    let headers = new Headers({ 'Content-Type' : 'application/x-www-form-urlencoded' });
    return this.http.get(this.server+"getmathotels", {
          headers:headers,
          method:"GET",                  
    }).map(
          (res:Response) => {return res.json();}
    )
  }

  assignRate(info) {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"gethotelsrates",data,this.options).map(res=>res.json());
  }

  editHotelMaterial(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"updatehotelmaterial",data,this.options).map(res=>res.json());
  }

  addHotelname(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"getname",data,this.options).map(res=>res.json());
  }

  deleteBill(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"deletebill",data,this.options).map(res=>res.json());
  }

  orderStatus(info)
  {
    var data = JSON.stringify(info);
    
    return this.http.post(this.server+"orderStatus",data,this.options).map(res=>res.json());
  }

  allHotels(info){
    var data = JSON.stringify(info);
    //console.log(data);

    return this.http.post(this.server+"allHotels",data,this.options).map(res=>res.json());
  }
 
  editHotel(info){
    var data = JSON.stringify(info);
    //console.log(data);

    return this.http.post(this.server+"editHotel",data,this.options).map(res=>res.json());
  }

  updateHotel(info){
    var data = JSON.stringify(info);
    //console.log(data);

    return this.http.post(this.server+"updateHotel",data,this.options).map(res=>res.json());
  }

  addUnit(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"addUnit",data,this.options).map(res=>res.json());
  }

  getUnits(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"getUnits",data,this.options).map(res=>res.json());
  }
  updateUnit(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"updateUnit",data,this.options).map(res=>res.json());
  }
  deleteUnit(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"deleteUnit",data,this.options).map(res=>res.json());
  }
  deleteHotel(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"deleteHotel",data,this.options).map(res=>res.json());
  }

  changeStatus(info){
    var data = JSON.stringify(info);

    return this.http.post(this.server+"changeStatus",data,this.options).map(res=>res.json());
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/services/hotel.service.ts